export default __webpack_public_path__ + "lock.svg";